module.exports = __webpack_public_path__ + "img/pr-10.e6a5b75b.png";